package dev.xcyn.site.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import org.jetbrains.compose.web.css.em
import dev.xcyn.site.CircleButtonVariant
import dev.xcyn.site.UncoloredButtonVariant

@Composable
fun IconButton(onClick: () -> Unit,
               modifier: Modifier = Modifier,
               content: @Composable () -> Unit) {
    Button(
        onClick = { onClick() },
        modifier.setVariable(ButtonVars.FontSize, 1.em).styleModifier { property("background", "none") }, // Make button icon size relative to parent container font size
        variant = CircleButtonVariant.then(UncoloredButtonVariant)
    ) {
        content()
    }
}
